import { render, staticRenderFns } from "./TicketsCreateAccess.vue?vue&type=template&id=7c0db50c&"
import script from "./TicketsCreateAccess.vue?vue&type=script&lang=ts&"
export * from "./TicketsCreateAccess.vue?vue&type=script&lang=ts&"
import style0 from "./TicketsCreateAccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VContainer,VForm,VSnackbar,VStepper,VStepperContent,VStepperStep})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c0db50c')) {
      api.createRecord('7c0db50c', component.options)
    } else {
      api.reload('7c0db50c', component.options)
    }
    module.hot.accept("./TicketsCreateAccess.vue?vue&type=template&id=7c0db50c&", function () {
      api.rerender('7c0db50c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/tickets-form/TicketsCreateAccess.vue"
export default component.exports